import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { useIntl } from 'react-intl';

import LoadingContainer from 'src/componentes/loading-container';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';

const SecaoOutros = ({ colaborador, isLoading, ...rest }) => {
  const intl = useIntl();
  const { user, terms: resources } = useAuth();

  return (
    <div className="border rounded-lg p-4 mb-4 shadow">
      <LoadingContainer isLoading={isLoading}>
        <div className="d-flex text-primary mb-3">
          <DocumentTextIcon
            style={{ width: '20px', marginBottom: '12px' }}
            className="mr-2"
          />
          <div className="text-primary text-base font-weight-bold mb-2 text-xl">
            {capitalizeFirstLetter(intl.formatMessage({ id: 'outros' }))}
          </div>
        </div>
        {!isLoading && (
          <DesenharCampoCustomizado
            disabled
            ignoreErrors
            mdFields={12}
            model={{
              label: intl.formatMessage({
                id: 'informacoesComplementares',
              }),
              value: colaborador?.camposCustomizados || [],
              requestChange: (e) => {},
            }}
          />
        )}
      </LoadingContainer>
    </div>
  );
};

export default SecaoOutros;
